import { useQuery } from '@apollo/client/react';
import get from 'lodash/get';
import {
  HypoNoeApiRequestDetailsDocument,
  type HypoNoeApiRequestDetailsQuery,
} from 'graphql/generated/graphql';

export type THypoNoeApiRequestDetails = HypoNoeApiRequestDetailsQuery['hypoNoeApiRequestDetails'];

const useGetHypoNoeApiRequestDetails = (
  requestId: string,
): [THypoNoeApiRequestDetails | null, boolean] => {
  const { data, loading } = useQuery(HypoNoeApiRequestDetailsDocument, {
    variables: { requestId },
  });
  const requestDetails = get(data, 'hypoNoeApiRequestDetails', null);
  return [requestDetails, loading];
};

export default useGetHypoNoeApiRequestDetails;
